module.exports = __webpack_public_path__ + "img/logo_wvi.42e13c3c.png";